export const handleToastError = (model, action) => {
  switch (action) {
    case action:
      return `Ops :(     Algo deu errado na action: ${action} ==> Model: ${model} !`;

    default:
      return `Ops :(     Algum erro desconhecido ocorreu, contate o suporte!`;
  }
};
